import { useEffect } from "react";

/* SEO Phase A — host platform/preview/unknown bukan storefront: pasang
   robots noindex,nofollow. Dilepas saat unmount agar tidak bocor ke tenant. */
export default function NoIndexMeta() {
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    let el = document.querySelector('meta[name="robots"]');
    const created = !el;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    const prev = el.getAttribute("content");
    el.setAttribute("content", "noindex,nofollow");
    el.setAttribute("data-managed", "seo-noindex");
    return () => {
      if (created) el.remove();
      else if (prev) el.setAttribute("content", prev);
    };
  }, []);
  return null;
}
